import './App.css';
import {Routes, Route, BrowserRouter} from 'react-router-dom';
import { AIv1 } from './components/AIv1';
import { Info } from './components/Info';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
      <Routes>
      <Route element={<AIv1 />} path='/' />
        <Route element={<AIv1 />} path='/aiv1' />
        <Route element={<Info />} path='/info' />
      </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
